app.service('invoiceService', function () {

  /*
    Proxied through the CRM server (/invoices/createInvoices) so the browser isn't
    subject to CORS on dashboard.texasptc.com. Returns the raw .zip as a Blob.
    Incoming OBJ: { user_ids: [31578], year: 2026 }
  */
  this.createInvoices = async function (obj) {
    try {
      const response = await fetch('/invoices/createInvoices', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj)
      })

      if (!response.ok) {
        // Errors come back from the proxy as JSON, not as a zip.
        let message = `HTTP ${response.status}`
        try {
          const error_body = await response.json()
          if (error_body && error_body.error) message = typeof error_body.error === 'string' ? error_body.error : JSON.stringify(error_body.error)
        } catch (e) { /* body wasn't JSON - keep the status message */ }
        return { success: false, error: { message: message } }
      }

      const blob = await response.blob()
      if (blob.size == 0) return { success: false, error: { message: 'The dashboard returned an empty file.' } }

      const header_count = response.headers.get('x-invoice-count')
      const invoice_count = header_count != null && /^\d+$/.test(header_count) ? parseInt(header_count, 10) : null

      return { success: true, blob: blob, invoice_count: invoice_count }
    } catch (error) {
      console.log('createInvoices-> error :>> ', error)
      return { success: false, error: error }
    }
  }

})
